<template>
  <section class="sign-in-pages">
    <AuthStage :sequence="false" wide>
      <template #brand>
        <AuthBrandLogo mode="plain" class="brand-logo--card" />
      </template>

      <template #controls>
        <button type="button" class="stage-btn" @click="onSignOut">Sign out</button>
      </template>

      <transition name="auth-card" mode="out-in">
        <router-view />
      </transition>
    </AuthStage>
  </section>
</template>

<script>
import AuthBrandLogo from '@/components/auth/AuthBrandLogo';
import AuthStage from '@/components/auth/AuthStage';

export default {
  name: 'AuthLayout',
  components: { AuthBrandLogo, AuthStage },
  methods: {
    // jalur logout sama dengan navbar aplikasi
    onSignOut() {
      this.$store.dispatch('auth/logout');
      window.location.href = '/auth/login';
    },
  },
};
</script>
